import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useWhatsappCallsRuntime } from './WhatsappCallsRuntimeContext';
import useFonemaOnCallEnd from '../fonema/actions/useFonemaOnCallEnd';

export default function useWhatsappOnCallEnd({ callInfoData, onClose }) {
  const { provider } = useWhatsappCallsRuntime();
  const activeCall = useSelector((state) => (
    provider === 'voice' ? state.voiceReducer.activeCall : null
  ));

  const onCloseRef = useRef(onClose);
  const previousActiveCallRef = useRef(activeCall);
  onCloseRef.current = onClose;

  useFonemaOnCallEnd({
    callInfoData,
    onClose,
    enabled: provider === 'fonema'
  });

  useEffect(() => {
    if (provider !== 'voice') {
      previousActiveCallRef.current = activeCall;
      return undefined;
    }

    const callId = callInfoData?.callId;
    if (!callId) return undefined;

    const wasActive = previousActiveCallRef.current?.callControlId === callId;
    const isStillActive = activeCall?.callControlId === callId;

    if (wasActive && !isStillActive) {
      onCloseRef.current?.(callId);
    }

    previousActiveCallRef.current = activeCall;
    return undefined;
  }, [provider, activeCall, callInfoData?.callId]);
}
